import { Container, styled } from "@mui/material";

export const StyledContainer = styled(Container)`
  padding: 1rem;
  transition: ease all 0.5s;
`;
